<!--<span *ngIf="type()">-->
<!-- <span istag="label" class="label" style="user-select: none" *ngFor="let l of label?.split('/')">{{ l }}<br /></span> -->
<span istag="label" class="label" style="user-select: none">{{ label }}<br/></span>
<!--</span>-->
